export { default } from "./Destaque";